import { render, staticRenderFns } from "./parametri.vue?vue&type=template&id=9c8ee4ac&scoped=true"
import script from "./parametri.vue?vue&type=script&lang=js"
export * from "./parametri.vue?vue&type=script&lang=js"
import style0 from "./parametri.vue?vue&type=style&index=0&id=9c8ee4ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8ee4ac",
  null
  
)

export default component.exports